<template>
    <section id="mobile-canvas-navigation">
        <div class="mobile-canvas-button d-flex justify-content-center align-items-center" @click="openBottomSheet()">
            <icon v-if="!project.map" name="ci-layer" color="white" scale="1.2" />
            <icon v-else name="map" color="white" scale="1.2" />
        </div>
        <SwipeableBottomSheet ref="swipeableBottomSheet" :currentTab="currentTab" @returnTab="returnTab" :isMap="Boolean(project.map)">
            <template v-if="project.map" v-slot:local-name>
                <div v-if="currentTab == 1" class="local-name">
                    {{ $t('keyword49') }}
                </div>
                <div v-else-if="currentTab == 2" class="local-name">
                    {{ selectedSector ? currentSector.name : $t('keyword50') }}
                </div>
                <div v-else-if="currentTab == 3" class="local-name">
                    {{ selectedFloorplan.name }}
                </div>
            </template>
            <template v-else v-slot:local-name>
                <div v-if="currentTab == 1" class="local-name">
                    {{ selectedSector ? currentSector.name : $t('keyword50') }}
                </div>
                <div v-else-if="currentTab == 2" class="local-name">
                    {{ selectedFloorplan.name }}
                </div>
            </template>
            <template v-slot:content v-if="project.map">
                <div class="content-container w-100 h-100">
                    <div class="canvas-container w-100 h-100">
                        <div v-if="project.map && currentTab == 1" class="map-canvas w-100 h-100">
                            <FloorplanCanvas
                                ref="zoomer"
                                v-if="!showViewpoints"
                                :floorplan="project.map.url"
                                :sectors="project.map.sectors"
                                @sectorClick="changeSector"
                            />
                            <FloorplanCanvas
                                ref="zoomer"
                                v-else
                                :floorplan="project.map.url"
                                :viewpoints="project.map.viewpoints"
                                :selectedViewpoint="currentViewpoint.id"
                                :grayscaleOnViewpointSelected="false"
                                @viewpointClick="changeViewpoint"
                            />

                            <b-tabs v-if="project.map.viewpoints" class="change-mode-tabs" justified small>
                                <b-tab @click="showViewpoints = false" :title="$t('keyword51')" active></b-tab>
                                <b-tab @click="showViewpoints = true" :title="$t('keyword52')"></b-tab>
                            </b-tabs>
                        </div>
                        <div v-else-if="currentTab == 2" class="floorplans-in-sector d-flex h-100">
                            <vue-custom-scrollbar class="w-100 h-100">
                                <ul class="floorplans-ul" v-if="selectedSector.floorplans && selectedSector.floorplans.length">
                                    <li v-for="floorplan in selectedSector.floorplans" :key="'floorplan-' + floorplan.id">
                                        <div @click.stop="changeFloorplan(floorplan)" class="floorplan w-100">
                                            <div class="name-grid w-100">
                                                <div class="icon d-flex justify-content-center align-items-center">
                                                    <icon
                                                        name="ci-layer"
                                                        :color="
                                                            floorplan.id == currentFloorplan.id && floorplan.viewpoints.length > 0
                                                                ? 'white'
                                                                : floorplan.viewpoints.length > 0
                                                                ? 'var(--secondary)'
                                                                : 'rgba(30, 179, 253, 0.5)'
                                                        "
                                                    />
                                                </div>
                                                <div class="floorplan-name">
                                                    {{ floorplan.name }}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </vue-custom-scrollbar>
                        </div>
                        <div v-else-if="currentTab == 3" class="floorplan-canvas w-100 h-100">
                            <FloorplanCanvas
                                ref="zoomer"
                                :floorplan="selectedFloorplan.url"
                                :viewpoints="selectedFloorplan.viewpoints"
                                :selectedViewpoint="currentViewpoint.id"
                                :grayscaleOnViewpointSelected="false"
                                @viewpointClick="changeViewpoint"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <template v-else v-slot:content>
                <div class="content-container w-100 h-100">
                    <div class="canvas-container w-100 h-100">
                        <div v-if="currentTab == 1" class="floorplans d-flex h-100">
                            <vue-custom-scrollbar class="w-100 h-100">
                                <ul class="floorplans-ul" v-if="project.floorplans && project.floorplans.length">
                                    <li v-for="floorplan in project.floorplans" :key="'floorplan-' + floorplan.id">
                                        <div @click.stop="changeFloorplan(floorplan)" class="floorplan w-100">
                                            <div class="name-grid w-100">
                                                <div class="icon d-flex justify-content-center align-items-center">
                                                    <icon
                                                        name="ci-layer"
                                                        :color="
                                                            floorplan.id == currentFloorplan.id && floorplan.viewpoints.length > 0
                                                                ? 'white'
                                                                : floorplan.viewpoints.length > 0
                                                                ? 'var(--secondary)'
                                                                : 'rgba(30, 179, 253, 0.5)'
                                                        "
                                                    />
                                                </div>
                                                <div class="floorplan-name">
                                                    {{ floorplan.name }}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </vue-custom-scrollbar>
                        </div>
                        <div v-else class="floorplan-canvas w-100 h-100">
                            <FloorplanCanvas
                                ref="zoomer"
                                :floorplan="selectedFloorplan.url"
                                :viewpoints="selectedFloorplan.viewpoints"
                                :selectedViewpoint="currentViewpoint.id"
                                :grayscaleOnViewpointSelected="false"
                                @viewpointClick="changeViewpoint"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </SwipeableBottomSheet>
    </section>
</template>

<script>
import 'vue-awesome/icons/map'
import 'vue-awesome/icons/arrows-alt-h'
import 'vue-awesome/icons/filter'
import 'vue-awesome/icons/layer-group'

import vueCustomScrollbar from 'vue-custom-scrollbar'
import SwipeableBottomSheet from '@/components/360Viewer/UI/Mobile/SwipeableBottomSheet'
import FloorplanCanvas from '@/components/FloorplanCanvas'

import { mapGetters } from 'vuex'

/**
 * Summary.
 * Mobile Canvas view for sectors and floorplans.
 *
 * @param {Object} currentSector
 * @param {Object} currentFloorplan
 * @param {Object} currentViewpoint
 * @param {Object} project
 *
 * @event onSelectViewpoint
 */

export default {
    components: {
        SwipeableBottomSheet,
        FloorplanCanvas,
        vueCustomScrollbar,
    },
    computed: {
        ...mapGetters('viewpointsSize', ['getById']),
    },
    props: {
        currentSector: Object,
        currentFloorplan: Object,
        currentViewpoint: Object,
        project: Object,
    },
    watch: {
        currentSector: function () {
            this.selectedSector = this.currentSector
        },
    },
    data() {
        return {
            currentTab: 1,
            selectedSector: null,
            selectedFloorplan: null,
            showViewpoints: false,
        }
    },
    methods: {
        returnTab() {
            if (this.currentTab >= 1) {
                this.currentTab--
            }
        },
        openBottomSheet() {
            this.$refs.swipeableBottomSheet.setState('open')
        },
        changeSector({ id }) {
            this.selectedSector = this.project.map.sectors.find((sector) => sector.id == id)
            this.currentTab = 2
        },
        changeViewpoint({ id }) {
            let vp = this.selectedFloorplan.viewpoints.find((vp) => vp.id == id)
            this.$emit('onSelectViewpoint', { fp: this.selectedFloorplan, vp })
            this.$refs.swipeableBottomSheet.setState('close')
        },
        changeFloorplan(floorplan) {
            this.selectedFloorplan = floorplan
            if (this.project.map) {
                this.currentTab = 3
            } else {
                this.currentTab = 2
            }
        },
        resetZoomer() {
            let zoomer = this.$refs.zoomer || this.$refs['zoomer-fullscreen']
            zoomer.resetScale()
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/components/360Viewer/UI/Mobile/floorplans-navigation.scss';
</style>

<style lang="scss">
#mobile-canvas-navigation {
    .change-mode-tabs {
        .nav-link {
            background-color: #3a3a3c;
            color: white;
        }
        .nav-link.active {
            background-color: #1c1c1e;
            border: 1px solid var(--secondary);
        }
    }
}
</style>
